module.exports = __webpack_public_path__ + "img/acquisition.ce7ae700.png";